import React from 'react';
// import { linksService } from './model/service';
import EUsefulLinks from './view/_useful-links';
export default function E_Links({keyWord,searchLinksData}){
    return (
        <EUsefulLinks 
        // getLinksData={linksService.getAuthLinks} 
        searchLinksData={searchLinksData} keyWord={keyWord}/>
    )
}